// Common countries with dial codes (compact, alphabetised by name).
export const COUNTRIES = [
    { name: "Australia", code: "AU", dial: "+61" },
    { name: "Botswana", code: "BW", dial: "+267" },
    { name: "Brazil", code: "BR", dial: "+55" },
    { name: "Canada", code: "CA", dial: "+1" },
    { name: "China", code: "CN", dial: "+86" },
    { name: "Egypt", code: "EG", dial: "+20" },
    { name: "Ethiopia", code: "ET", dial: "+251" },
    { name: "France", code: "FR", dial: "+33" },
    { name: "Germany", code: "DE", dial: "+49" },
    { name: "Ghana", code: "GH", dial: "+233" },
    { name: "India", code: "IN", dial: "+91" },
    { name: "Italy", code: "IT", dial: "+39" },
    { name: "Japan", code: "JP", dial: "+81" },
    { name: "Kenya", code: "KE", dial: "+254" },
    { name: "Lesotho", code: "LS", dial: "+266" },
    { name: "Malawi", code: "MW", dial: "+265" },
    { name: "Mexico", code: "MX", dial: "+52" },
    { name: "Mozambique", code: "MZ", dial: "+258" },
    { name: "Namibia", code: "NA", dial: "+264" },
    { name: "Netherlands", code: "NL", dial: "+31" },
    { name: "New Zealand", code: "NZ", dial: "+64" },
    { name: "Nigeria", code: "NG", dial: "+234" },
    { name: "Portugal", code: "PT", dial: "+351" },
    { name: "Saudi Arabia", code: "SA", dial: "+966" },
    { name: "South Africa", code: "ZA", dial: "+27" },
    { name: "Spain", code: "ES", dial: "+34" },
    { name: "Sweden", code: "SE", dial: "+46" },
    { name: "Switzerland", code: "CH", dial: "+41" },
    { name: "Tanzania", code: "TZ", dial: "+255" },
    { name: "Uganda", code: "UG", dial: "+256" },
    { name: "United Arab Emirates", code: "AE", dial: "+971" },
    { name: "United Kingdom", code: "GB", dial: "+44" },
    { name: "United States", code: "US", dial: "+1" },
    { name: "Zambia", code: "ZM", dial: "+260" },
    { name: "Zimbabwe", code: "ZW", dial: "+263" },
];
